import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./InstallApp.css";

export default function InstallApp() {
  const [installPrompt, setInstallPrompt] = useState(null);
  const [showInstructions, setShowInstructions] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    setIsInstalled(
      window.matchMedia("(display-mode: standalone)").matches ||
        window.navigator.standalone === true
    );

    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setInstallPrompt(event);
    };
    const handleAppInstalled = () => {
      setIsInstalled(true);
      setInstallPrompt(null);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    window.addEventListener("appinstalled", handleAppInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
      window.removeEventListener("appinstalled", handleAppInstalled);
    };
  }, []);

  const handleInstall = async () => {
    if (!installPrompt) {
      setShowInstructions(true);
      return;
    }

    await installPrompt.prompt();
    const choice = await installPrompt.userChoice;
    if (choice.outcome === "accepted") setIsInstalled(true);
    setInstallPrompt(null);
  };

  return (
    <main className="pwa-install">
      <section className="pwa-install-card">
        <div className="pwa-install-mark" aria-hidden="true">S</div>
        <p className="pwa-install-eyebrow">SHAHA GROUP</p>
        <h1>Install Admin Portal</h1>
        <p className="pwa-install-description">
          Add the admin portal to your home screen for quick, app-like access.
        </p>
        {isInstalled ? (
          <p className="pwa-install-status" role="status">This app is already installed on this device.</p>
        ) : (
          <button className="pwa-install-button" onClick={handleInstall}>
            Install app
          </button>
        )}
        {showInstructions && (
          <div className="pwa-install-help" role="status">
            <strong>Install from your browser menu</strong>
            <p>On Android, open the browser menu and choose “Install app” or “Add to Home screen”.</p>
            <p>On iPhone or iPad, open this page in Safari, tap Share, then choose “Add to Home Screen”.</p>
          </div>
        )}
        <Link className="pwa-install-back" to="/login">Continue to admin sign in</Link>
      </section>
    </main>
  );
}
